import React from 'react';
const rows = [{
  before: 'Noches enteras buscando ejercicios de fútbol que no conectan entre sí.',
  after: 'Sesiones de FÚTBOL listas en 5 minutos directamente en tu móvil o tablet.'
}, {
  before: 'Estrés antes de cada sesión por no saber qué trabajar con grupos de distintas categorías.',
  after: 'Seguridad total al entrar a la cancha con explicaciones tácticas claras y profesionales.'
}, {
  before: 'Jugadores aburridos por ejercicios repetitivos y falta de objetivos claros.',
  after: 'Entrenamientos dinámicos y competitivos que motivan a tus jugadores cada día.'
}, {
  before: 'Padres que cuestionan tu capacidad porque no tienes datos de progreso que mostrar.',
  after: 'Informes de evaluación técnica para mostrar resultados reales a los padres.'
}];
export function ContrastSection() {
  return <section className="w-full bg-bg-main py-20 px-4" data-id="element-36">
      <div className="max-w-4xl mx-auto" data-id="element-37">
        {/* Time cost callout */}
        <div className="bg-badge-red/10 border border-badge-red/20 rounded-2xl p-6 sm:p-8 mb-12 text-center" data-id="element-38">
          <p className="text-text-main text-lg sm:text-2xl font-bold leading-relaxed" data-id="element-39">
            Planificar cada sesión de FÚTBOL de forma manual te quita entre{' '}
            <span className="text-badge-red font-black" data-id="element-40">
              3 y 5 horas por semana
            </span>
            . Son{' '}
            <span className="text-badge-red font-black" data-id="element-41">
              más de 150 horas al año perdidas
            </span>{' '}
            en dibujos, búsquedas en YouTube y estrés de último minuto.
          </p>
        </div>

        <div className="bg-bg-alt rounded-2xl shadow-2xl border border-border-light overflow-hidden" data-id="element-42">
          {/* Header */}
          <div className="grid grid-cols-1 md:grid-cols-2 border-b border-border-light bg-white/5" data-id="element-43">
            <div className="px-6 py-5 font-bold text-badge-red text-center md:text-left border-b md:border-b-0 md:border-r border-border-light tracking-wider text-sm" data-id="element-44">
              SIN FÚTBOL LISTO (Tu vida actual)
            </div>
            <div className="px-6 py-5 font-black text-primary text-center md:text-left tracking-wider text-sm drop-shadow-[0_0_8px_rgba(59,130,246,0.3)]" data-id="element-45">
              CON FÚTBOL LISTO (Tu nueva realidad)
            </div>
          </div>

          {/* Rows */}
          <div className="divide-y divide-border-light" data-id="element-46">
            {rows.map((row, i) => <div key={i} className="grid grid-cols-1 md:grid-cols-2 group hover:bg-white/[0.02] transition-colors" data-id="element-47">
                <div className="px-6 py-6 flex items-start gap-4 border-b md:border-b-0 md:border-r border-border-light bg-black/20" data-id="element-48">
                  <div className="w-6 h-6 rounded-full bg-badge-red/20 flex items-center justify-center flex-shrink-0 mt-0.5 border border-badge-red/30" data-id="element-49">
                    <span className="text-badge-red font-bold text-sm" data-id="element-50">✕</span>
                  </div>
                  <p className="text-text-sec font-medium" data-id="element-51">{row.before}</p>
                </div>
                <div className="px-6 py-6 flex items-start gap-4 bg-primary/5 relative overflow-hidden" data-id="element-52">
                  <div className="absolute inset-0 bg-gradient-to-r from-primary/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-53"></div>
                  <div className="w-6 h-6 rounded-full bg-check-green/20 flex items-center justify-center flex-shrink-0 mt-0.5 border border-check-green/30 relative z-10" data-id="element-54">
                    <span className="text-check-green font-bold text-sm" data-id="element-55">
                      ✓
                    </span>
                  </div>
                  <p className="text-text-main font-bold relative z-10" data-id="element-56">
                    {row.after}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}